import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { mediaQuery } = baseVariables;

export const StyledImageTray = styled.div`
  .image-cards {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: ${toRem(20)};

    @media ${mediaQuery.md} {
      flex-direction: row;
    }

    @media ${mediaQuery.lg} {
      max-height: ${toRem(250)};
    }
  }
`;
